module.exports = __webpack_public_path__ + "static/media/img.9a93b4e3.png";